export const getErrorMessage = ({ message, error }: { message?: string; error: QueryError | undefined }) => {
    if (error?.response?.data) return error.response.data;
    if (message && message.length > 0) return message;
    return 'Something went wrong';
};
